import api from "../../utils/ApiConfig";

export const fetchCharges = async (archivees = false) => {
  const response = await api.get(
    `/bo/charges-mensuelles${archivees ? "?archivees=1" : ""}`
  );
  return response.data;
};

// Edition groupee des MONTANTS seuls : on ajuste plusieurs lignes et on
// enregistre une fois. Le libelle et la categorie passent par updateCharge,
// pour qu'une correction de chiffre ne puisse pas ecraser un intitule.
export const bulkUpdateCharges = async (charges) => {
  const response = await api.put("/bo/charges-mensuelles/bulk", { charges });
  return response.data;
};

export const createCharge = async (charge) => {
  const response = await api.post("/bo/charges-mensuelles", charge);
  return response.data;
};

export const updateCharge = async (id, charge) => {
  const response = await api.put(`/bo/charges-mensuelles/${id}`, charge);
  return response.data;
};

// Arrete la charge, ne l'efface pas : le serveur pose une date de fin. Pour une
// charge qui s'arrete vraiment ; une ligne saisie par erreur se supprime.
export const archiverCharge = async (id, actifAu = null) => {
  const response = await api.delete(`/bo/charges-mensuelles/${id}`, {
    data: actifAu ? { actif_au: actifAu } : {},
  });
  return response.data;
};

// Supprime definitivement la ligne : pour une charge saisie par erreur.
export const supprimerCharge = async (id) => {
  const response = await api.delete(`/bo/charges-mensuelles/${id}/definitif`);
  return response.data;
};
